import {teamsConstants} from '../constants';

const teamsState = {
  list: [],
  loaded: false
};

const teamsReducer = (state = teamsState, action) => {
  const {type, data} = action;
  switch (type) {
    case teamsConstants.GET_TEAMS:
      return {
        ...state,
        list: data,
        loaded: true
      }
    case teamsConstants.ADD_TEAM:
      // Ignore if the team is already present (e.g. a refetch raced the add).
      if (!data?.team_id || state.list.some((team) => team.team_id === data.team_id)) return state;
      return {
        ...state,
        list: [...state.list, data]
      }
    case teamsConstants.DELETE_TEAM:
      return {
        ...state,
        list: state.list.filter((team) => team.team_id !== data)
      }
    case teamsConstants.CLEAR_TEAMS:
      return teamsState
    default:
      return state;
  }
};

export default teamsReducer;
